import React, { useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/react-hooks'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import {
  Table,
  Space,
  Input,
  InputNumber,
  Form,
  Image,
  Tag,
  Button,
  List,
  Badge
} from 'antd'
import {
  EditOutlined,
  // PrinterOutlined,
  // SyncOutlined,
  PlusOutlined
} from '@ant-design/icons'
import moment from 'moment'
import { flatMap, merge as LMerge } from 'lodash-es'
import DataTableServices from '../../../../services/datatableServices'
import { contrastColor } from 'contrast-color'
import { price_render, color_render, customer_render, Tags_render } from '../DataTools/DataField'
import DataNewItem from '../DataTools/DataNewItem'
import DataEditItem from '../DataTools/DataEditItem'
import useAsyncQuery from '../../../../ultils/useAsyncQuery'
import StockProductModal from '../DataTools/StockProductModal'
import { removeVietnameseCharMark, colorByQuanity, imagePreset, getRevisionData, buildFilterByParam, updateFilterParam, price_k } from '../../../../ultils/datatableUtils'

import PrintOrderDetail from '../../../printer/Product/PrintOrderDetail'
import GiuhangModal from './Product/GiuhangModal'

// import { Anchor } from 'antd';

// const { Link } = Anchor;

const defaultLimit = 25

const DataTableRows = ({
  usersStore,
  datatableStore,
  commonStore,
  table,
  updateFilter
}) => {
  const [columns, setColumns] = useState(false)
  const [aggregate, setAggregate] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentEditRecord, setCurrentEditRecord] = useState(false)
  const [currentSLGiuhang, setCurrentSLGiuhang] = useState(false)
  const [codeSelect, setCodeSelect] = useState(false)
  const [currentRecordClickData, setCurrentRecordClickData] = useState(false)
  const [showQuickSLPrice, setShowQuickSLPrice] = useState(false)

  const [form] = Form.useForm()

  const [updateManyDataRows] = useMutation(
    DataTableServices.UPDATE_MANY_ROWS(),
    {
      errorPolicy: 'all'
    }
  )
  const [updateStockProduct] = useMutation(
    DataTableServices.UPDATE_STOCK_PRODUCT(),
    {
      errorPolicy: 'all'
    }
  )
  let history = useHistory();
  // const disposer = observe(datatableStore, change => {
  //   // console.log(`change`, toJS(change))
  //   if (change.name === 'rowEditingKey' && change.type === 'update') {
  //     if (!change.oldValue || !datatableStore.tempValue) return
  //     // console.log(`change`, toJS(change))
  //     // console.log(`tempValue`, tempValue)
  //     saveChangedRow(datatableStore.tempValue.oldRow, datatableStore.tempValue.newRow)

  //     // if (change.object['rowEditingKey']) {
  //     //   saveChangedRow(tempValue)
  //     // } else {
  //     //   saveChangedRow(tempValue,true)
  //     // }
  //   }
  //   // 
  // })

  const findRowsQuery = useAsyncQuery(DataTableServices.FIND_ROW_BY_FILTER())

  const findRowsByFilter = async (dataInput) => {
    const { data, error } = await findRowsQuery({
      input: {
        data: dataInput
      }
    })
    let results = data?.findDataRow?.data
    if (!results?.items) return false
    var items = flatMap(results.items, myFlat)
    return items
  }


  const findRows = async (cols) => {
    // if (!updateFilter._sort && datatableStore.filterUpdated._sort) updateFilter._sort = datatableStore.filterUpdated._sort
    if (!updateFilter) {
      updateFilter = { _sort: 'ngay_tao:-1' }
    } else {
      if (!updateFilter._sort) updateFilter._sort = 'ngay_tao:-1'
    }
    if (!updateFilter.limit) updateFilter.limit = 40
    if (!updateFilter.start) updateFilter.start = 0
    setLoading(true)
    let dataInput = {
      columns: cols,
      tableId: table.id,
      hasPreSearch: true,
      // txt: datatableStore.filterData.txt,
      // start: datatableStore.filterData.start,
      // limit: datatableStore.filterData.limit
      filter: updateFilter,
      // filter: filter
      // sort: [['row_data.ngay_tao', 'desc']],
      // limit: limit ? limit : defaultLimit,
      // limit:40,
      ref_data: table?.table_data?.ref_data || false
    }
    // if (datatableStore.filterData.sort) dataInput.sort = datatableStore.filterData.sort
    const { data, error } = await findRowsQuery({
      input: {
        data: dataInput
      }
    })
    // console.log('data', data)
    // console.log('data', data?.findDataRow?.data)
    let results = data?.findDataRow?.data
    // console.log(`results`, results)
    if (!results?.items) return false
    // console.log(`results.aggregate`, results.aggregate)
    setAggregate(results.aggregate)
    // setPageSize(datatableStore.filterData.limit)
    var items = flatMap(results.items, myFlat)
    datatableStore.setSelectedRowKeys([])
    datatableStore.setCurrentDatarows(items)
    setLoading(false)
    return data?.findDataRow?.data
  }

  useEffect(() => {
    async function fetchData() {
      if (table.id) {
        if (table.type === 'order') {
          let statusData = await findRowsByFilter(
            {
              tableId: commonStore?.company?.companyData?.status_table,
              // tableId: '607d523459c61c2d08f434b2', // SUA LAI SAU
              hasPreSearch: false,
              limit: 500,
              // filter: { match: { "category": ['Trạng thái đơn', "Vận chuyển", "Thanh toán"] } }
            }
          )
          let orderStatus = statusData.filter(item => item.category === 'Trạng thái đơn')
          let shipStatus = statusData.filter(item => item.category === 'Vận chuyển')
          let paymentStatus = statusData.filter(item => item.category === 'Thanh toán')
          // console.log(`paymentStatus`, paymentStatus)
          let tagData = await findRowsByFilter(
            {
              tableId: commonStore?.company?.companyData?.tag_table,
              // tableId: '607d523459c61c2d08f434b2', // SUA LAI SAU
              hasPreSearch: false,
              limit: 500,
              filter: { match: { "category": ['Đơn hàng', 'Sản phẩm'] } }
            }
          )
          datatableStore.setPreloadTable('tags', tagData)
          datatableStore.setPreloadTable('status', orderStatus)
          datatableStore.setPreloadTable('shipStatus', shipStatus)
          datatableStore.setPreloadTable('paymentStatus', paymentStatus)

        }
        else if (table.type === 'product') {
          let tagData = await findRowsByFilter(
            {
              tableId: commonStore?.company?.companyData?.tag_table,
              // tableId: '607d523459c61c2d08f434b2', // SUA LAI SAU
              hasPreSearch: false,
              limit: 500,
              filter: { match: { "category": ['Sản phẩm'] } }
            }
          )
          datatableStore.setPreloadTable('tags', tagData)
        }
        datatableStore.setCurrentDatarows([])
        // setDefaultCurrent(1)
        initColumn()
        // stopAutoSync()
        datatableStore.resetFilter()
        datatableStore.setSelectedRowKeys([])
      }
      // startAutoSync()
    }
    fetchData();
    return () => {
      setColumns(false)
      datatableStore.setCurrentDatarows([])
      setAggregate(false)
      // setDefaultCurrent(1)
      // stopAutoSync()
    }
  }, [table.id])

  useEffect(() => {
    async function fetchData() {
      if (table.id) {
        await findRows(['code', 'name'])
      }
    }
    fetchData();
  }, [
    updateFilter,
    datatableStore.filterUpdated
  ])

  // function getDefaultCurrent() {
  //   // let df = toJS(datatableStore.dataFilter)
  //   // if (!df) return 1
  //   // let limit = df?.limit ? df.limit : defaultLimit
  //   // let current = Math.floor((df.start ? df.start : 0) / limit) + 1
  //   // return current
  //   let limit = updateFilter?.limit ? updateFilter.limit : defaultLimit
  //   let current = Math.floor((updateFilter.start ? updateFilter.start : 0) / limit) + 1
  //   return current
  // }

  // const getRevisionData = (oldRow, newRow) => {
  //   let out = {
  //     o: {},
  //     n: {},
  //     id: oldRow.key
  //   }
  //   if (out.id.length <= 10) { // tu hieu la them moi
  //     out.add = LMerge(oldRow, newRow)
  //     out.add.table = table.id
  //     return out
  //   }
  //   let notFound = true
  //   for (const [key, value] of Object.entries(newRow)) {
  //     if (oldRow[key] !== value) {
  //       notFound = false
  //       out.o[key] = oldRow[key]
  //       out.n[key] = newRow[key]
  //     }
  //   }
  //   return (notFound ? false : out)
  // }

  const saveChangedRow = async (oldRow, newRow, clearRowKey) => {
    try {
      if (!newRow) newRow = await form.validateFields()
      else {
        if (!oldRow) {
          oldRow = toJS(datatableStore.currentDatarows).find(item => item.sid === newRow.sid)
        }
      }
      let se = false
      let column_search = table.table_data?.column_search
      if (column_search) {
        column_search.forEach(s => {
          let key = s?.key
          let v = newRow[key]
          if (v !== undefined) {
            if (s.extra && (s.extra?.type == 'text' || !s.extra?.type)) {
              // if (s.extra.type === "stock_products") {
              //   v = ""
              //   row[key].forEach(code => {
              //     v = v + " " + code
              //   })
              // }
              if (s.extra.vn && v) v = removeVietnameseCharMark(v)
              if (s.extra.lowercase && v) v = v.toLowerCase()
            }
            if (!se) se = v
            else
              se += " " + v
          }
        });
      }
      // datatableStore.updateRow(row, sid)

      let attrs = table?.table_scheme?.attributes
      for (const [kk, vv] of Object.entries(newRow)) {
        if (attrs[kk] && attrs[kk].type === 'number') {
          let newPrice = parseInt(vv)
          if (attrs[kk].sub_type === 'price' && (newPrice > 1 && newPrice < 3000))
            newPrice = newPrice * 1000
          newRow[kk] = newPrice
        }
      }

      const newData = [...datatableStore.currentDatarows]
      const index = newData.findIndex(item => oldRow.sid === item.sid)

      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...newRow })
        let changeData = getRevisionData(toJS(oldRow), toJS(newRow), table.id)
        if (changeData) {
          changeData.id = oldRow.key
          if (se)
            changeData.se = se
          datatableStore.setCurrentDatarows(newData)
          update2db([changeData])
        }
      }


      // if (index > -1) {
      //   const item = newData[index]
      //   newData.splice(index, 1, { ...item, ...newRow })
      //   let changeData = getRevisionData(toJS(oldRow), toJS(newRow), table.id)
      //   if (changeData) {
      //     changeData.id = oldRow.key
      //     datatableStore.setCurrentDatarows(newData)
      //     const indexInChanged = datatableStore.changedRows.findIndex(
      //       r => oldRow.key === r.id
      //     )
      //     if (indexInChanged < 0) {
      //       console.log('push save ' + oldRow.sid)
      //       if (se)
      //         changeData.se = se
      //       datatableStore.setChangedRows([...datatableStore.changedRows, changeData])
      //     } else {
      //       datatableStore.changedRows[indexInChanged].o = LMerge({ ...changeData.o }, datatableStore.changedRows[indexInChanged].o)
      //       datatableStore.changedRows[indexInChanged].n = LMerge(datatableStore.changedRows[indexInChanged].n, changeData.n)
      //       if (se) datatableStore.changedRows[indexInChanged].se = se
      //     }
      //   }
      // } else {
      //   newData.push(newRow)
      //   datatableStore.setCurrentDatarows(newData)
      // }


      if (clearRowKey)
        datatableStore.setRowEditingKey('')
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo)
    }
  }

  useEffect(() => {
    if (datatableStore.newRowData) {
      // let r = 
      // console.log(`rows`, rows)
      // setRows(datatableStore.newRowData.concat(datatableStore.currentDatarows))
      datatableStore.setCurrentDatarows(datatableStore.newRowData.concat(datatableStore.currentDatarows))
    }
    return () => {

    }
  }, [datatableStore.newRowData])

  // useEffect(() => {
  //   if (selectedRecord) {
  //     if (datatableStore.rowEditingKey && tempValue) {
  //       // if (selectedRecord.sid != tempValue.sid) {
  //       //   // saveChangedRow(tempValue, true)
  //       //   // setCurrentEditColumn(c.dataIndex)
  //       //   // edit(selectedRecord)
  //       // } else {
  //       //   saveChangedRow(tempValue, true)
  //       // }
  //       saveChangedRow(tempValue, true)
  //       setTempValue(false)
  //     }
  //     edit(selectedRecord)
  //   }

  //   // return () => {

  //   // }
  // }, [tempValue, selectedRecord])

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const save = async e => {
      var elem = e.srcElement || e.target
      // record[dataIndex] = elem.value

      // datatableStore.setTempValue(false)
      await saveChangedRow(record, false, true)
      // setCurrentEditColumn(false)
      // datatableStore.setRowEditingKey(false)
      // datatableStore.updateRow(record, record.sid)
    }

    const saveBlur = async e => {
      // var elem = e.srcElement || e.target
      // let tmp = {
      //   oldRow: toJS(record),
      // }
      // record[dataIndex] = elem.value
      // tmp.newRow = toJS(record)
      // datatableStore.setTempValue(tmp)
    }

    const onKeyDown = async e => {
      if (e.key == "Enter") {
        await save(e)
        e.preventDefault()
      }
      else if (e.key == "Escape") {
        datatableStore.setRowEditingKey(false)
        e.preventDefault()
      }
    }


    const inputRef = useRef(null);

    // useEffect(() => {
    //   if (inputRef.current && currentEditColumn == dataIndex) {
    //     // console.log(`dataIndex`, dataIndex)
    //     inputRef.current.focus({
    //       cursor: 'all',
    //     });
    //   }
    // }, [])

    let inputNode
    switch (inputType) {
      case 'number':
        inputNode = <InputNumber
          // tabIndex={index}
          size={'small'}
          ref={inputRef}
          onBlur={saveBlur}
          // onPressEnter={save}
          onKeyDown={onKeyDown}

        />
        break;

      case 'tag-color':

      default:
        inputNode = <Input
          // autoFocus={true}
          // tabIndex={index}s
          ref={inputRef}
          // onPressEnter={save}
          onKeyDown={onKeyDown}
          onBlur={saveBlur}
        // onClick={() => {
        //   if (inputRef.current)
        //     inputRef.current.focus({
        //       cursor: 'all',
        //     });
        // }}
        />
    }

    // const inputNode =
    //   inputType === 'number' ? (
    //     <InputNumber
    //       // tabIndex={index}
    //       ref={inputRef}
    //       // onBlur={saveBlur}
    //       onPressEnter={save} />

    //   ) : (
    //     <Input
    //       // autoFocus={true}
    //       // tabIndex={index}s
    //       ref={inputRef}
    //       onPressEnter={save}
    //     // onBlur={saveBlur}
    //     // onClick={() => {
    //     //   if (inputRef.current)
    //     //     inputRef.current.focus({
    //     //       cursor: 'all',
    //     //     });
    //     // }}
    //     />
    //   )
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
              width: 'auto'
            }}
          // rules={[
          //   {
          //     required: true,
          //     message: `Please Input ${title}!`,
          //   },
          // ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    )
  }
  var updateInterval = null

  const update2db = async (changedRows) => {
    var input = {
      data: {
        type: "oldnew",
        rows: changedRows
      }
    }
    // message.loading({ content: 'đang lưu dữ liệu...', key: 'saving' });
    let r = await updateManyDataRows({
      variables: { input }
    })
    let result = r.data?.updateManyDataRows?.data
    return result
    // if (result.status === 'OK' && result.changeId) {
    //   let ar = [...datatableStore.currentDatarows]
    //   ar.forEach(item => {
    //     if (result.changeId[item.key]) {
    //       item.key = result.changeId[item.key]
    //     }
    //   });
    //   datatableStore.setCurrentDatarows(ar)
    // }
  }

  // const update2db = async () => {
  //   if (datatableStore.changedRows.length < 1) return
  //   var input = {
  //     data: {
  //       type: "oldnew",
  //       rows: toJS(datatableStore.changedRows)
  //     }
  //   }
  //   // message.loading({ content: 'đang lưu dữ liệu...', key: 'saving' });
  //   let r = await updateManyDataRows({
  //     variables: { input }
  //   })
  //   let result = r.data?.updateManyDataRows?.data
  //   if (result.status === 'OK' && result.changeId) {
  //     let ar = [...datatableStore.currentDatarows]
  //     ar.forEach(item => {
  //       if (result.changeId[item.key]) {
  //         item.key = result.changeId[item.key]
  //       }
  //     });
  //     datatableStore.setCurrentDatarows(ar)
  //   }
  //   // message.success(
  //   //   {
  //   //     content: `Đã đồng bộ ${datatableStore.changedRows.length} dữ liệu!`,
  //   //     key: 'saving'
  //   //   });
  //   // console.log('r', r)
  //   datatableStore.setChangedRows([])
  //   return r
  // }

  // const startAutoSync = () => {
  //   updateInterval = setInterval(() => {
  //     update2db()
  //   }, 8000)
  // }

  // const stopAutoSync = () => {
  //   if (updateInterval) {
  //     clearTimeout(updateInterval)
  //     updateInterval = null
  //   }
  // }



  // autorun(() => {
  //   console.log("bbbbbbb:", datatableStore.changedRows)
  //   if (datatableStore.changedRows.length>0) {
  //     datatableStore.changedRows = []
  //     console.log('remove all')
  //   }
  // })

  const stock_quanity_render = (value, row, index) => {
    if (!value) {
      value = 0
      if (row.stock && row.stock.length > 0) {
        row.stock.forEach(s => {
          if (!s.qty) s.qty = 1
          value += parseInt(s.qty)
        });
      }
    }
    return <span style={{ fontWeight: "bold", color: colorByQuanity(value) }}>{value}</span>
  }

  const stock_product_render = (value, row, index) => {

    return (
      <div style={{ margin: "10px 0" }}>
        <Button
          onClick={() => {
            setCurrentRecordClickData({ index: index, row: row })
            setCodeSelect({ qty: 1 })
          }}
          icon={<PlusOutlined />}
          style={{ background: "#bbbbbb", marginRight: 8 }}
          size={"small"}>
          sp
        </Button>
        {value ?
          value.map(item => {
            // let color = "#D6AD5C"
            // if (!item.qty) item.qty = 1
            // if (item.qty > 20) color = "#52BE7A"
            // else if (item.qty > 10) color = "#5296BE"
            let color = colorByQuanity(item.qty)
            return (
              <Tag color={color}
                style={{ marginBottom: 6, padding: 8 }}
                onClick={() => {
                  setCurrentRecordClickData({ index: index, row: row })
                  setCodeSelect(toJS(item))
                }}>
                <strong>{item.code}</strong>({item.qty})
              </Tag>
            )
          }) : ""
        }
      </div>
    )
    // return <span style={{ display: 'block', width: 50, height: 15, border: "1px solid #333", backgroundColor: value }}></span>
  }

  const isEditing = record => {
    return record.sid == datatableStore.rowEditingKey
  }

  const edit = record => {
    form.setFieldsValue({
      ...record
    })
    if (datatableStore.rowEditingKey !== '')
      datatableStore.setRowEditingKey(record.sid)
  }

  // const cancel = () => {
  //   datatableStore.setRowEditingKey('')
  // }

  // function two_digit(v) {
  //   return ('0' + v).slice(-2)
  // }

  function initColumn() {
    // console.log(`table`, table)
    if (!table.table_columns)
      table.table_columns = table?.data_table_template?.table_columns
    if (!table.table_columns) return

    let actionColumn = {
      title: '',
      dataIndex: 'sid',
      width: 35,
      render: (value, row, index) => {
        return (
          <>
            {table.table_data.column_quick && table.table_data.column_quick.length > 0
              && <EditOutlined
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  // alert(row.code)
                  setCurrentEditRecord(row)
                }}
              />
            }
            {commonStore?.company?.companyData?.order_table === table.id ? <PrintOrderDetail title='In'
              orderData={toJS(row)}
              columns={['name', 'qty', 'price', 'priceItems']}
              noLabel
            /> : ""}
            {/* {commonStore?.company?.companyData?.product_table === table.id &&
              (['chu-cong-ty'].includes(usersStore.currentUser.company_role)) &&
              <SyncOutlined
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  
                }} />
            } */}

          </>
        )
      }
    }
    // console.log('dataColumns', dataColumns)
    let dataColumns = [actionColumn, ...table.table_columns]
    // let dataColumns = []
    // if (table.table_data.column_quick && table.table_data.column_quick.length > 0) {
    //   dataColumns = [actionColumn, ...table.table_columns]
    // } else {
    //   dataColumns = table.table_columns
    // }
    // dataColumns.push(actionColumn)

    let so = datatableStore.dataFilter?.sort
    let tIndex = 2

    dataColumns.forEach((c) => {
      let scheme = table.table_scheme ? table.table_scheme : table.data_table_template.table_schema
      // let attr = false
      let attr = scheme?.attributes
      if (attr)
        attr = attr[c.dataIndex]
      // if (table.table_scheme?.attributes)
      //   attr = table.table_scheme?.attributes[c.dataIndex]
      if (!c.type) c.type = 'text'
      if (c.editable) {
        if (c.type === 'number' || c.type === 'text')
          c.onCell = record => ({
            record,
            inputType: c.type,
            dataIndex: c.dataIndex,
            index: tIndex,
            title: c.title,
            editing: isEditing(record),
            onDoubleClick: event => {
              // if (datatableStore.rowEditingKey && tempValue) {
              //   saveChangedRow(tempValue, true)
              //   setTempValue(false)
              // }
              // setCurrentEditColumn(c.dataIndex)
              edit(record)
              datatableStore.setRowEditingKey(record.sid)
              event.preventDefault()
            },

            onClick: event => {

              // if (datatableStore.rowEditingKey && tempValue) {
              //   saveChangedRow(tempValue, true)
              //   setTempValue(false)
              // }
              if (datatableStore.rowEditingKey !== '') {
                // setCurrentEditColumn(c.dataIndex)
                edit(record)
                event.preventDefault()
              }
            },
            // onClick: event => {
            //   console.log(` selected record`, record)
            //   if (datatableStore.rowEditingKey && tempValue) {
            //     saveChangedRow(tempValue, true)
            //     setTempValue(false)
            //   }
            //   setCurrentEditColumn(c.dataIndex)
            //   edit(record)
            //   event.preventDefault()
            // } // d
          })
        tIndex++
      }

      if (c.type === 'text' && attr?.click_detail) {
        c.render = (value, row, index) => {
          if (table.type === 'report')
            return (
              <a href={'/report/' + row.key} target="_blank" title={value}>{value}</a>
            )

          if (table.type === 'pcollection')
            return (
              // <span
              //   onClick={() => {
              //     history.replace('/row/' + row.key)
              //   }}
              // >{value}</span>

              <a href={'/row/' + row.key} title={value}>{value}</a>
            )

          return (
            <a href={'/row/' + row.key} target="_blank" title={value}>{value}</a>
          )
        }
        // history.push({
        //   pathname: '/row/' + id,
        // })
      }



      if (c.type === 'text' && attr?.sub_type === 'product_name') {
        // console.log(`attr`, attr)
        c.render = (value, row, index) => {
          let ngay_kiem = moment(row.ngay_kiem)
          var today = moment().startOf('day');
          var days = Math.round(moment.duration(today - ngay_kiem).asDays());
          let color = "red"
          if (days < 40 && row.ngay_kiem) color = "green"
          if (days > 40 && row.ngay_kiem) color = "blue"
          let nameColor = row.co_mau_live ? '#60CC7B' : '#333'
          return (
            <>
              {/* <Badge status={(days < 20 && row.ngay_kiem) ? 'success' : "error"} text={row['name']} style={{ color: (days < 20 && row.ngay_kiem) ? 'green' : "#777" }} /> */}
              <Badge color={color} text={row['name']} style={{ color: nameColor }} />
              <br />
              {/* {row.tag_chungloai && datatableStore.preloadTable.tags &&
                <Tags_render tags={row.tag_chungloai} preloadTable={datatableStore.preloadTable.tags} />
              } */}
              {row.tag_group && datatableStore.preloadTable.tags &&
                <Space className='small-tag'>
                  <Tags_render tags={row.tag_group} preloadTable={datatableStore.preloadTable.tags} />
                  <br />
                </Space>
              }
              {row.tag_chungloai && datatableStore.preloadTable.tags &&
                <Space className='small-tag'>
                  <Tags_render tags={row.tag_chungloai} preloadTable={datatableStore.preloadTable.tags} />
                  <br />
                </Space>
              }
              {row?.tag_vitri && datatableStore.preloadTable.tags &&
                <Space className='small-tag'>
                  <Tags_render tags={row.tag_vitri} preloadTable={datatableStore.preloadTable.tags} subCate="Tag vị trí" hasColor={false} />
                  <br />
                </Space>
              }
              {row['note'] ?
                <span style={{ fontSize: '8pt', color: "#00B500", fontStyle: 'italic' }}>{row['note']}</span>
                :
                ""}

            </>
          )
        }
      }

      if (c.type === 'text' && attr?.sub_type === 'product_code') {
        // console.log(`attr`, attr)
        c.render = (value, row, index) => {
          if (row['sl_id']) {
            return <strong style={{ color: 'blue' }}>{value}</strong>
          }
          return value
        }
      }

      if (c.type === 'cotheban') {
        c.render = (value, row, index) => {
          let gh = row.sl_giuhang > 0 ? row.sl_giuhang : 0
          let sl = row.sl_tonkho - gh
          let color = "green"
          if (sl <= 0) color = "red"
          return (<span style={{ color: color, fontWeight: 'bold' }}>
            {sl}
          </span>)
        }
        return
      }

      if (attr?.sub_type === 'sl_qty') {
        c.render = (value, row, index) => {
          if (value !== 0 && !value) return '-'
          let gh = row.sl_giuhang > 0 ? row.sl_giuhang : 0
          let cotheban = row.sl_tonkho - gh
          let color = "green"
          if (cotheban !== value) color = "red"
          return (<span style={{ color: color, fontWeight: 'bold' }}>
            {value}
          </span>)
        }
        return
      }

      if (attr?.sub_type === 'giuhang') {
        c.render = (value, row, index) => {
          // let gh = row.sl_giuhang > 0 ? row.sl_giuhang : 0
          // let sl = row.sl_tonkho - gh
          let color = "gray"
          if (row.giuhang && row.giuhang.length > 0) {
            color = "blue"
          }
          if (row.sl_giuhang <= 0) color = "#eee"
          return (
            <span
              style={{ color: color, fontWeight: 'bold' }}
              onClick={() => {
                if (row.giuhang) {
                  setCurrentSLGiuhang({
                    pCode: row.code,
                    giuhang: row.giuhang
                  })
                }
              }}
            >
              {row.sl_giuhang}
              {/* {row.giuhang && <>({row.giuhang.length})</>} */}
            </span>)
        }
        return
      }


      if (c.type === 'image') {
        c.render = (value, row, index) => {
          let thumbnail = imagePreset(value, 'xsmall')
          // var s = ''
          // if (!row[c.dataIndex]) {
          //   var d = new Date(row.ngay_tao)
          //   s = `https://statics.tpos.vn/images/nhaiu/${d.getYear() - 100
          //     }${d.getMonth() + 1}${d.getDate()}/${two_digit(
          //       d.getUTCHours()
          //     )}${two_digit(d.getMinutes())}${two_digit(
          //       d.getSeconds()
          //     )}_product_${row.sid}.jpg?width=40&height=40`
          //   row[c.dataIndex] = s
          // } else {
          //   s = row[c.dataIndex]
          // }
          // return <Avatar shape="square" size="large" src={row[c.dataIndex]} />
          return <Image
            width={60}
            height={60}
            src={thumbnail}
            preview={{
              src: value,
            }}
          // src={row[c.dataIndex] ? row[c.dataIndex] : ""}
          // fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
          />
        }
        return
      } else if (c.transformData === 'live_messages') {
        c.render = (value, row, index) => {
          return row.mcount
        }
      }

      if (c.type === 'color') {
        c.render = color_render
        return
      }

      if (c.format === 'price-vn' || c.sub_type === "price_vn") {
        c.render = price_render
        return
      }

      if (c.type === "object-id") {
        if (attr) {
          if (attr.sub_type === 'color') {
            c.render = (value, row, index) => {
              let name = row[c.dataIndex]?.name
              let color = row[c.dataIndex]?.color
              if (attr.ref) {
                let refObject = row[c.dataIndex]?.ref
                if (refObject && refObject.color && refObject.name) {
                  name = refObject.name
                  color = refObject.color
                  // return <Tag color={refObject.color} style={{ color: contrastColor({ bgColor: refObject.color }) }}  >{refObject.name}</Tag>
                }
              }
              if (color && name)
                return <Tag color={color} style={{ color: contrastColor({ bgColor: color }) }}  >{name}</Tag>
              return value
            }
          } else if (attr.sub_type === 'customer') {
            c.render = (value, row, index) => {
              return customer_render(value, row, index, toJS(datatableStore.preloadTable))
            }
          } else {
            c.render = (value, row, index) => {
              let name = ""
              if (attr.ref) {
                if (attr.ref?.display_columns) {
                  if (row[c.dataIndex])
                    name = row[c.dataIndex][attr.ref.display_columns[0]]
                }
              }
              return name
              // return customer_render(value, row, index, toJS(datatableStore.preloadTable))
            }
          }
        }
      }

      if (c.type === 'status') {

      }

      if (c.type === "stock_product") {
        c.render = stock_product_render
      }

      if (c.type === 'stock_qty') {
        c.render = stock_quanity_render
      }

      // if (c.sorter) {
      //   c.sorter = eval(c.sorter)
      // }
      if (c.sort) {
        if (!so) so = []
        // so.push([c.dataIndex, c.sort])
        so.push([c.dataIndex + ":" + c.sort])
        so = so.join(',')
        datatableStore.setFilterUpdated({ _sort: so })
      }
      if (c.dateFormat) {
        c.render = (value, row, index) => {
          // if (table.table_data.due_rule) {
          //   let m2 = moment().day(-table.table_data.due_rule.day_number);
          //   let m1 = moment(value)

          //   if (m1.isBefore(m2)) {
          //     return (
          //       <span style={{ color: 'red' }}>{m1.format('DD/MM/YY HH:mm')}</span>
          //     )
          //   }
          // }
          // let n = 
          if (!value) return "???"
          var m = moment(value).format('DD/MM/YY HH:mm')
          return m
        }
      }
    })
    // if (so) setSort(so)
    // console.log(`so`, so)
    // if (so) datatableStore.setFilter({ sort: so })

    setColumns(dataColumns)
    // console.log(`so`, so)
  }

  function myFlat(v) {
    return Object.assign(v.row_data, { key: v.id })
  }

  const onPageChange = (pagination, filters, sorter) => {
    let search = false
    let updateF = {}
    if (sorter.order) {
      let order = sorter.order === "ascend" ? 1 : -1
      updateF._sort = sorter.column.dataIndex + ":" + order
      // setStart(0)
    }
    // console.log(`pagination`, pagination)
    updateF.start = (pagination.current - 1) * pagination.pageSize
    if (pagination.pageSize !== updateFilter.limit) {
      // updateF.start = 0
      updateF.limit = pagination.pageSize
    }
    // console.log(`updateF`, updateF)
    if (Object.keys(updateF).length > 0) {
      search = updateFilterParam(updateFilter, updateF)
    }
    // console.log(`search`, search)
    history.push({
      pathname: '/table/' + table.id,
      search: search,
    })
  }

  useEffect(() => {
  }, [datatableStore.rowEditingKey])


  const rowSelection = {
    selectedRowKeys: datatableStore.selectedRowKeys,
    onChange: (srk) => {
      datatableStore.setSelectedRowKeys(srk)
      // console.log(`srk`, srk)
    }
  };

  const updateStockRow = (stockId, stockData) => {
    datatableStore.setCurrentDatarows(
      datatableStore.currentDatarows.map((row) => {
        return row.key === stockId ? { ...row, products: stockData } : row;
      })
    )
  }

  const child_render = (record) => {
    return (
      <div style={{ background: "#eee", padding: 30 }}>
        <List
          // style={{ background: "#E1EBE1" }}
          size="small"
          dataSource={record.items}
          bordered
          renderItem={item => {
            // let cotheban = item.sl_tonkho - item.sl_giuhang
            // let ctbColor = 'green'
            // if (cotheban <= 0) ctbColor = 'red'
            // if (isNaN(cotheban)) {
            //   cotheban = '?'
            //   ctbColor = '#aaa'
            // }
            return (
              <List.Item>
                <div>
                  <span style={{ marginRight: 15 }}>
                    <strong>{item.code}</strong>
                  </span>
                  <span style={{ marginRight: 10 }}>
                    <a href={'/table/5fe7fb4d2136a764ac573c1e?code=' + item.code} target="_blank" title={item.name}>{item.name}</a>
                  </span>
                  <span style={{ marginRight: 10 }}>
                    <strong>{price_k(item.price, '?', 3)}</strong>
                  </span>
                  <span style={{ marginRight: 10 }}>
                    SL: <strong>{item.qty}</strong>
                  </span>
                  {/* <span style={{ marginRight: 10 }}>
                    CTB:  <strong style={{ color: ctbColor }}>{cotheban}</strong>
                  </span> */}
                </div>
              </List.Item>
            )
          }
          }
        />
      </div>
    )
  }

  // const exp = {
  //   expandable: {
  //     expandedRowRender: child_render,
  //     rowExpandable: record => record.code,
  //   }
  // }
  return (
    <>
      {/* {columns && table.id && datatableStore.filterData && datatableStore.filterData.limit ? ( */}
      {columns && table.id && datatableStore.filterUpdated ? (
        <Form form={form} component={false}>
          <Table
            loading={loading}
            className={'mainTable'}
            // onRow={(record, rowIndex) => {
            //   return {
            //     onDoubleClick: event => {
            //       edit(record)
            //       event.preventDefault()
            //     } // double click row
            //   }
            // }}
            components={{
              body: {
                cell: EditableCell
              }
            }}
            rowClassName="editable-row"
            columns={columns}
            // dataSource={rows}
            dataSource={datatableStore.currentDatarows}
            // scroll={{ x: 800, y:'calc(100vh - 200px)' }}
            scroll={{ x: 800 }}
            rowSelection={rowSelection}
            pagination={{
              // defaultCurrent: defaultCurrent,
              // defaultCurrent: getDefaultCurrent(),
              current: Math.floor((updateFilter.start ? updateFilter.start : 0) / (updateFilter.limit ? updateFilter.limit : defaultLimit)) + 1,
              // pageSize: datatableStore.dataFilter ? datatableStore.dataFilter.limit : defaultLimit,
              // pageSize: pageSize ? pageSize : defaultLimit,
              pageSize: updateFilter.limit ? updateFilter.limit : defaultLimit,
              showLessItems: true,
              showSizeChanger: true,
              size: 'small',
              defaultPageSize: 40,
              // pageSizeOptions: [25, 50, 100, 200, 300],
              pageSizeOptions: [25, 50, 80, 100, 200, 500],
              total: aggregate ? aggregate.count : 0,
              showTotal: total => `${total} dữ liệu`,
              position: ['none', 'bottomLeft']
            }}
            onChange={onPageChange}
            size="small"

            expandable={
              commonStore?.company?.companyData?.order_table === table.id &&
              {
                expandedRowRender: child_render,
                rowExpandable: record => record.code,
              }}

          // expandable={{
          //   expandedRowRender: record => <p style={{ margin: 0 }}>{record.name}</p>,
          //   rowExpandable: record => record.name !== 'Not Expandable',
          // }}
          />
        </Form>
      ) : (
        ''
      )}
      {currentEditRecord && (
        <DataEditItem
          title={'Chỉnh sửa chi tiết'}
          initData={currentEditRecord}
          table={table}
          onSave={v => {
            // console.log('v', v)
            setCurrentEditRecord(false)
          }}
          onClose={() => {
            setCurrentEditRecord(false)
          }}
        />
      )}

      {currentSLGiuhang && (
        <GiuhangModal
          data={currentSLGiuhang}
          onClose={() => {
            setCurrentSLGiuhang(false)
          }}
        />
      )}

      {datatableStore.showAddModal ? (
        <DataNewItem
          title={`Thêm ${datatableStore.dataTextName}`}
          table={toJS(table)}
          // tableId={id}
          onSave={v => {
            // console.log('v', v)
            if (v.status === 'OK') {
              var newItem = myFlat(v.data)
              if (newItem) {
                datatableStore.setCurrentDatarows([newItem, ...datatableStore.currentDatarows])
                // setRows([newItem, ...rows])
              }
            }
            datatableStore.setShowAddModal(false)
          }}
          onClose={() => {
            datatableStore.setShowAddModal(false)
          }}
        />
      ) : (
        ''
      )}

      {codeSelect ?
        <StockProductModal
          initData={codeSelect}
          onSave={async (v) => {
            let input = {
              data: {
                product_update: v,
                stock_update: toJS(currentRecordClickData.row)
              }
            }
            // cap nhat so luong vao kho va san pham lien quan
            let r = await updateStockProduct({
              variables: { input }
            })
            let rdata = r.data?.updateStockProduct?.data
            if (rdata.status === 'OK') {
              updateStockRow(rdata.out?.id, rdata.out?.products)
            }
            // console.log(`r`, r)
            setCodeSelect(false)
          }}
          onClose={() => {
            setCodeSelect(false)
          }}
        />
        : ""
      }
    </>
  )
}

export default inject(
  'usersStore',
  'datatableStore',
  'commonStore'
)(observer(DataTableRows))
